import apiFetch from 'utils/apiFetch';
import * as ACTION_TYPE from './types';

export function saveBoost(boost) {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPE.SAVE_BOOST_INIT,
    });

    apiFetch('POST', { endPoint: 'boost' }, boost)
      .then((data) => {
        dispatch({
          type: ACTION_TYPE.SAVE_BOOST_SUCCESS,
          payload: {
            data,
          },
        });
      })
      .catch(() => {
        dispatch({
          type: ACTION_TYPE.SAVE_BOOST_FAILURE,
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/components/Boost/modules/actions.js